export function getToday() { // 获取当前今天日期
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    };
    return year + '-' + month + '-' + strDate;
}

export function exToLv(ex) { // 经验转换成等级,和当前等级溢出经验
    var lv = 1;
    var val = 0;
    return exToLvTools(lv, val, ex);
}

function exToLvTools(lv, val, ex) { // 经验转换成等级,和当前等级溢出经验
    var tVal = val;
    val = val + lv * 10;
    var map = {
        grade: 1,
        exEx: 0,
        currentLvMaxEx: 0
    }
    if (val > ex) {
        map.grade = lv;
        map.exEx = ex - tVal;
        map.currentLvMaxEx = lv * 10;
        return map;
    } else {
        map = exToLvTools(lv + 1, val, ex);
    }
    return map;
}

// 格式判断
export function userIDCheck(i) {
    var patt = /^[1-9]\d*$/;
    if (patt.test(i)) { // 正整数
        return true;
    }
    return false;
}

// 格式判断
export function amountFormatCheck(i) {
    if (i === 0) { // 是否为 0
        return true;
    }
    var patt = /^[1-9]\d*$/;
    if (patt.test(i)) { // 正整数
        return true;
    }
    var patt = /^0\.\d*[1-9]$/;
    if (patt.test(i)) { // 小于0且带小数
        return true;
    }
    var patt = /^[1-9]\d*\.\d*[1-9]$/;
    if (patt.test(i)) { // 大于0且带小数
        return true;
    }
    return false;
}


import JSEncrypt from "jsencrypt"

// // 加密
// export function encrypt(data, publicKey) {
//     console.log("jsencrypt 加密");
//     var encryptor = new JSEncrypt();
//     encryptor.setPublicKey(publicKey);
//     return encryptor.encrypt(data);
// }

// 解密
// export function decrypt(data,privateKey) {
//     var encryptor = new JSEncrypt();
//     encryptor.setPrivateKey(privateKey);
//     return encryptor.decrypt(data);
// }

import Encryptlong from "encryptlong"

// 加密
export function encrypt(data, publicKey) {
    var encryptlong = new Encryptlong();
    encryptlong.setPublicKey(publicKey);
    return encryptlong.encryptLong(data);
}

// 解密
export function decrypt(data, privateKey) {
    var encryptlong = new Encryptlong();
    encryptlong.setPrivateKey(privateKey);
    return encryptlong.decryptLong(data);
}

import CryptoJS from "crypto-js";
// 十六位十六进制数作为密钥
const SECRET_KEY = CryptoJS.enc.Utf8.parse("475765701abc"); // 必须12位
// 十六位十六进制数作为密钥偏移量
const SECRET_IV = CryptoJS.enc.Utf8.parse("475765701abc"); // 必须12位

/**
 * 加密方法
 * @param data
 * @returns {string}
 */
export function encryptWeb(data) {
    if (typeof data === "object") {
        try {
            // eslint-disable-next-line no-param-reassign
            data = JSON.stringify(data);
        } catch (error) {
            console.log("encrypt error:", error);
        }
    }
    const dataHex = CryptoJS.enc.Utf8.parse(data);
    const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString();
}

/**
 * 解密方法
 * @param data
 * @returns {string}
 */
export function decryptWeb(data) {
    const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
    const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}

// AES 加密解密

import request from '../utils/request'

export function getPublicKey() {
    return request({
        method: 'get',
        url: '/common/getPublicKey',
    })
}

export function getWeather() {
    return request({
        method: 'get',
        url: '/common/getWeather',
    })
}

export function getSystemInfo(params) {
    return request({
        method: 'post',
        url: '/common/getSystemInfo',
        data: params,
    })
}

//获得浏览器名称
// 获取浏览器类型
export function getBrowserType() {
    // 获取浏览器 userAgent
    var ua = navigator.userAgent

    // 是否为 Opera
    var isOpera = ua.indexOf('Opera') > -1
    // 返回结果
    if (isOpera) { return 'Opera' }

    // 是否为 IE
    var isIE = (ua.indexOf('compatible') > -1) && (ua.indexOf('MSIE') > -1) && !isOpera
    var isIE11 = (ua.indexOf('Trident') > -1) && (ua.indexOf("rv:11.0") > -1)
    // 返回结果
    if (isIE11) { return 'IE11'
    } else if (isIE) {
        // 检测是否匹配
        var re = new RegExp('MSIE (\\d+\\.\\d+);')
        re.test(ua)
        // 获取版本
        var ver = parseFloat(RegExp["$1"])
        // 返回结果
        if (ver == 7) { return 'IE7'
        } else if (ver == 8) { return 'IE8'
        } else if (ver == 9) { return 'IE9'
        } else if (ver == 10) { return 'IE10'
        } else { return "IE" }
    }

    // 是否为 Edge
    var isEdge = ua.indexOf("Edge") > -1
    // 返回结果
    if (isEdge) { return 'Edge' }

    // 是否为 Firefox
    var isFirefox = ua.indexOf("Firefox") > -1
    // 返回结果
    if (isFirefox) { return 'Firefox' }

    // 是否为 Safari
    var isSafari = (ua.indexOf("Safari") > -1) && (ua.indexOf("Chrome") == -1)
    // 返回结果
    if (isSafari) { return "Safari" }

    // 是否为 Chrome
    var isChrome = (ua.indexOf("Chrome") > -1) && (ua.indexOf("Safari") > -1) && (ua.indexOf("Edge") == -1)
    // 返回结果
    if (isChrome) { return 'Chrome' }

    // 是否为 UC
    var isUC= ua.indexOf("UBrowser") > -1
    // 返回结果
    if (isUC) { return 'UC' }

    // 是否为 QQ
    var isQQ= ua.indexOf("QQBrowser") > -1
    // 返回结果
    if (isUC) { return 'QQ' }

    // 都不是
    return ''
}
/**
 * 时间类型格式转换
 * @param {*} dateArray 待格式化的时间
 * @param {*} code 标识,依据此标识将时间格式化成特定格式
 *  0:[YYYY, MM, DD, HH, MM, SS] > YYYY/MM/DD HH:MM:SS
 *  1:yyyy-MM-dd'T'HH:mm:ss > YYYY年MM月DD日 HH:MM:SS
 * @returns 
 */
export function formatDate(dateInfo, code) {
    if (code == 0) {
        // 创建一个 Date 对象
        const date = new Date(dateInfo[0], dateInfo[1] - 1, dateInfo[2], dateInfo[3], dateInfo[4], dateInfo[5]);

        // 格式化日期为可读的字符串
        const formattedDate = date.toLocaleDateString('zh-CN'); // 使用中文格式
        const formattedTime = date.toLocaleTimeString('zh-CN'); // 使用中文格式

        // 返回格式化后的日期和时间
        return `${formattedDate} ${formattedTime}`;
    }
    else if (code == 1) {
        const date = new Date(dateInfo);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份从 0 开始，所以需要加 1
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
     
        // 格式化为 "YYYY年MM月DD日 HH:MM:SS"
        return `${year}年${month.toString().padStart(2, '0')}月${day.toString().padStart(2, '0')}日 ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

}
export function formatFileSize(fileSize) {  // 文件大小格式转换
    if (fileSize<1024) {
        return fileSize + "B";
    }
    fileSize = Math.floor(fileSize/1024*100)/100;
    if (fileSize<1024) {
        return fileSize + "KB";
    }
    fileSize = Math.floor(fileSize/1024*100)/100;
    if (fileSize<1024) {
        return fileSize + "MB";
    }
    fileSize = Math.floor(fileSize/1024*100)/100;
    if (fileSize<1024) {
        return fileSize + "GB";
    }
}

export function randomStr(size) {  // 获取指定长度的随机数字字符串,不含0
    var str = "";
    for (let index = 0; index < size; index++) {
        str = str.concat((Math.floor(Math.random() * 9)+1).toString());
        
    }
    return str;
}
/**
 * yyyy-MM-dd'T'HH:mm:ss 格式时间与当前时间比较大小
 * @param {*} dateString 
 * @returns 参数大:1 相等:0 参数小:-1
 */
export function compareDateWithCurrent(dateString) {
    // 将日期字符串解析为 Date 对象
    const inputDate = new Date(dateString);
    
    // 获取当前时间的 Date 对象
    const currentDate = new Date();
 
    // 比较两个日期
    if (inputDate > currentDate) {
        return 1;
    } else if (inputDate < currentDate) {
        return -1;
    } else {
        return 0;
    }
}